import type { Path } from '../utils/resolvePath';
import { walkObjectDeeply } from '../utils/walkObjectDeeply';
import type { ActionValueSnapshotOut } from './types/ScriptConfigSchema/ActionValue';
import type { ScriptConfiguration } from './types/ScriptConfiguration';

export function walkScriptConfigInteractivityActionValues(
  scriptConfig: ScriptConfiguration,
  walk: (actionField: ActionValueSnapshotOut, path: Path) => void,
) {
  walkObjectDeeply(scriptConfig, (value, path) => {
    if (typeof value === 'object' && value !== null && '$type' in value) {
      const { $type } = value as { $type: string };

      switch ($type) {
        case 'action': {
          const actionField = value as ActionValueSnapshotOut;
          if (actionField) {
            walk(actionField, path);
          }
          break;
        }

        default:
          break;
      }
    }
  });
}
